import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
    persist(
        (set) => ({
            // --- ÉTAT (STATE) ---
            user: null,
            accessToken: null,
            refreshToken: null,
            isAuthenticated: false,

            // --- ACTIONS ---

            /**
             * Appelé lors du Login initial
             * Stocke l'utilisateur et les deux jetons
             */
            setAuth: (data) => set({
                user: data.user,
                accessToken: data.accessToken,
                refreshToken: data.refreshToken,
                isAuthenticated: true,
            }),

            setMustChangePassword: (status) => set((state) => ({
                user: state.user ? { ...state.user, mustChangePassword: status } : null
            })),

            /**
             * Appelé par l'intercepteur Axios lors d'un Silent Refresh
             * Met à jour uniquement le jeton d'accès sans toucher au reste
             */
            updateAccessToken: (newToken) => set({
                accessToken: newToken
            }),

            /**
             * Appelé manuellement ou suite à une expiration du Refresh Token
             * Vide complètement le store et le localStorage
             */
            logout: () => set({
                user: null,
                accessToken: null,
                refreshToken: null,
                isAuthenticated: false,
            }),
        }),
        {
            name: 'miracle-travel-auth', // Nom de la clé dans le localStorage
            // Par défaut, persist utilise localStorage, ce qui est parfait ici.
        }
    )
);